module.exports = __webpack_public_path__ + "img/help_content3.310b879a.png";